import { createFeatureSelector, createSelector } from '@ngrx/store';
import { StudyDataState } from './reducers';
import _ from 'lodash-es';

export const selectStudyDataState = createFeatureSelector<StudyDataState>('selectedStudy');

export const selectStudy = createSelector(selectStudyDataState, (data) => data.study);

export const isStudyLoaded = createSelector(selectStudy, (study, props) => !!study.data && study.data.studyId === props.studyId);

export const selectStudyData = createSelector(selectStudy, (study) => study.data);

export const selectStudyDatabaseNames = createSelector(selectStudy, (study) =>
  !!study && !!study.studyDatabases ? _.mapValues(_.keyBy(study.studyDatabases, 'databaseId'), 'databaseName') : {}
);

export const selectStudyDatabases = createSelector(selectStudy, (study) => (!!study && !!study.studyDatabases ? study.studyDatabases : []));

export const selectStudyFilters = createSelector(selectStudy, (study) => (!!study && !!study.studyFilters ? study.studyFilters : []));

export const selectStudyItemsPerPage = createSelector(selectStudyData, (study) => (study ? study.itemsPerPage : undefined));

export const selectStudyId = createSelector(selectStudyData, (study) => (study ? study.studyId : undefined));

export const selectPeriodOfStudyFrom = createSelector(selectStudyData, (study) => (study ? study.periodOfStudyFrom : undefined));

export const selectPeriodOfStudyTo = createSelector(selectStudyData, (study) => (study ? study.periodOfStudyTo : undefined));

export const rowsPerPageOptions = createSelector(selectStudy, (study) => study.consts.rowsPerPageOptions);

export const pageLinkSize = createSelector(selectStudy, (study) => study.consts.pageLinkSize);
